import React, { useEffect, useState } from "react";
import { Button, Table } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import { IoArrowUndoSharp } from "react-icons/io5";
import "../admin/style.css";
import noavatar from "../../assets/img/noavatar.png";
import { getData } from "../../api/method";

function OrderDetails() {
  const navigate = useNavigate();

  const { id } = useParams();

  const [data, setData] = useState([]);
  const [dataOrder, setDataOrder] = useState([]);

  const getOrderDetail = async () => {
    try {
      const result = await getData(`/api/OrderDetail/${id}`);
      setData(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getOrderByUser = async () => {
    try {
      const result = await getData(`/api/Order/${id}`);
      setDataOrder(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getOrderDetail();
    getOrderByUser();
  }, []);

  return (
    <div className="w-100 pt-4 px-5 py-5">
      <div className="d-flex justify-content-between">
        <Button
          className="btn_add fs-20 d-flex align-items-center"
          onClick={() => navigate("/admin/order")}
        >
          <IoArrowUndoSharp className="me-2" />
          Back
        </Button>
      </div>

      <div className="py-4 text-start ms-5 ps-5">
        <p className="fs-24">
          Customer Name: <span className="t-primary">{dataOrder?.user?.lastname} {dataOrder?.user?.firstname}</span>
        </p>
        <p className="py-2 fs-24">
          Address:{" "}
          <span className="t-primary t-capitalize">{dataOrder?.address} {dataOrder?.ward} {dataOrder?.district} {dataOrder?.city}</span>
        </p>
        <p className="fs-24">
          Phone: <span className="t-primary">{dataOrder?.user?.phone}</span>
        </p>
      </div>

      <Table className="table_admin mt-3">
        <thead>
          <tr className="fw-bold">
            <th className="table_od_stt">#</th>
            <th className="table_od_img">Image</th>
            <th className="table_od_name">Name</th>
            <th className="table_od_trademark">Brand</th>
            <th className="table_od_price">Price</th>
            <th className="table_od_percent">Percent</th>
            <th className="table_od_dimension--detail" colSpan={2}>
              Dimension
            </th>
            <th className="table_od_quantity">Quantity</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item, i) => (
            <tr key={item.id}>
              <td className="table_od_stt">{i}</td>

              <td className="table_od_img">
                <img
                  src={
                    `${process.env.REACT_APP_URL_IMAGE + item.product.image}` ||
                    noavatar
                  }
                  alt="product"
                  width={50}
                  height={50}
                />
              </td>
              <td className="table_od_name">
                <div className=" table_od_name--custom">
                  {item.product.name}
                </div>
              </td>
              <td className="table_od_trademark">
                {item.product.category.name}
              </td>
              <td className="table_od_price">
                {(
                  (item.product.price * (100 - item.product.discount)) /
                  100
                ).toLocaleString("vi")}
                &#273;
              </td>
              <td className="table_od_percent">{item.product.discount}%</td>
              <td className="table_od_dimension--detail">
                {item.product.dimension}ml
              </td>
              <td className="table_od_quantity">{item.quantity}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

export default OrderDetails;
